import { render, staticRenderFns } from "./InsolvencyTask.vue?vue&type=template&id=6e2c48a8&scoped=true&"
import script from "./InsolvencyTask.vue?vue&type=script&lang=js&"
export * from "./InsolvencyTask.vue?vue&type=script&lang=js&"
import style0 from "./InsolvencyTask.vue?vue&type=style&index=0&id=6e2c48a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2c48a8",
  null
  
)

export default component.exports